import { render, staticRenderFns } from "./BatchStartups.vue?vue&type=template&id=6433c89a&scoped=true"
import script from "./BatchStartups.vue?vue&type=script&lang=js"
export * from "./BatchStartups.vue?vue&type=script&lang=js"
import style0 from "./BatchStartups.vue?vue&type=style&index=0&id=6433c89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433c89a",
  null
  
)

export default component.exports